"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SinglePinMap = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactGoogleMaps = require("@vis.gl/react-google-maps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/prop-types */

var googleMapUiKey = '';
if (typeof window !== 'undefined') {
  googleMapUiKey = window.GOOGLE_MAPS_API_KEY;
}
var SinglePinMap = _ref => {
  var {
    lat,
    lng
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.APIProvider, {
    apiKey: googleMapUiKey,
    version: "beta"
  }, /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.Map, {
    style: {
      width: "100%",
      height: "574.4px"
    },
    options: {
      mapId: "a1338bda8d063b0a",
      streetViewControl: false,
      clickableIcons: false,
      zoomControl: true,
      zoomControlOptions: {
        position: _reactGoogleMaps.ControlPosition.TOP_RIGHT
      },
      panControl: false,
      mapTypeControl: false,
      scrollwheel: false,
      fullscreenControl: false,
      cameraControl: false
    },
    defaultZoom: 15,
    defaultCenter: {
      lat: lat,
      lng: lng
    },
    disableDefaultUI: false
  }, /*#__PURE__*/_react.default.createElement(MarkerWithInfoWindow, {
    position: {
      lat: lat,
      lng: lng
    }
  }))));
};
exports.SinglePinMap = SinglePinMap;
var MarkerWithInfoWindow = props => {
  var [markerRef, marker] = (0, _reactGoogleMaps.useAdvancedMarkerRef)();
  var {
    position
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.AdvancedMarker, {
    position: position,
    ref: markerRef
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-map-pin-fill"
  })));
};